import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';

const Progress = ({ status }) => {
    let color = 'secondary';
    let progressType = 'indeterminate';
    let doneContent = (
        <Typography variant="caption" component="div" color="textSecondary">
            {status?.current}
        </Typography>
    );

    if (!status) {
        progressType = 'determinate';
        color = 'inherit';
        doneContent = (
            <Typography variant="caption" component="div" color="textSecondary">
                -
            </Typography>
        );
    } else if (status.active === false) {
        progressType = 'determinate';
        color = 'primary';
        doneContent = <CheckIcon />;
    }

    return (
        <Box position="relative" display="inline-flex">
            <CircularProgress variant={progressType} value={100} color={color} />
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                {doneContent}
            </Box>
        </Box>
    );
};

export default Progress;
